import locationApi from "./locationApi"

/* Seuils de fraîcheur par catégorie de lieu (Z7-30), stockés par
   location-service et lus par la détection des trous (type « périmé »).
   Clé : id de la catégorie au référentiel des types de lieu (admin-service). */

export interface SeuilFraicheur {
  categorieId: number
  libelle: string
  jours: number
  majLe?: string
  majPar?: string
}

export interface EtatSeuilsFraicheur {
  seuils: SeuilFraicheur[]
  /** Seuil d'une catégorie sans réglage ni défaut propre. */
  defautJours: number
  /** Défauts propres à certaines catégories, par libellé. */
  defautsParCategorie: Record<string, number>
  joursMin: number
  joursMax: number
}

export async function getSeuilsFraicheur(): Promise<EtatSeuilsFraicheur> {
  const res = await locationApi.get('/trou/seuils-fraicheur')
  return res.data
}

export async function reglerSeuilFraicheur(categorieId: number, libelle: string, jours: number) {
  const res = await locationApi.put(`/trou/seuils-fraicheur/${categorieId}`, { libelle, jours })
  return res.data as SeuilFraicheur
}

/** Retour à la valeur par défaut de la catégorie. */
export async function retirerSeuilFraicheur(categorieId: number) {
  await locationApi.delete(`/trou/seuils-fraicheur/${categorieId}`)
}

/** Texte d'erreur de location-service ({ erreur }), ou le libellé de repli. */
export function messageSeuil(err: any, repli: string): string {
  const d = err?.response?.data
  if (d && typeof d.erreur === 'string' && d.erreur.trim()) return d.erreur.trim()
  return repli
}
